module.exports = __webpack_public_path__ + "d27092d06f8c0ff13a97790317ed318f.png";